import PropTypes from "prop-types";
import { useInView } from "react-intersection-observer";
import { useBestInTravel } from "@context/bestInTravel/2025/bestInTravelContext";
import { tagular } from "@cohesion/tagular";

import { Arrow } from "@icons/elsewhere";
import { ImgixNextBackground } from "@components/imgixNextBackground";
import { Button } from "@components/button";

import { useEffect } from "react";
import { SailyLogo } from "./sailyLogo";

export function SailyDestinationSection({ index }) {
  const { handleUpDownNavProvider } = useBestInTravel();

  /**
   * Lazyloading
   */
  const { ref: sailySectionRef, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView) {
      tagular("view", {
        webElement: {
          location: "BIT_Saily",
          elementType: "SECTION",
          position: "0",
        },
      });
    }
  }, [inView]);

  return (
    <div ref={sailySectionRef} className="w-screen h-screen-dvh">
      <div className="relative flex flex-col h-full sm:flex-row">
        {/* CONTENT SECTION */}
        <div className="bg-[#e2edff] h-full w-full order-2 sm:order-1 sm:w-1/3 px-6 pb-20 sm:pb-0 lg:px-12 pt-6 sm:pt-0 flex flex-col justify-center">
          <div className="flex flex-col flex-grow gap-4 sm:gap-6 sm:justify-center sm:flex-grow-0">
            <SailyLogo className="w-16 h-7 sm:w-[84px] sm:h-9" />
            <div className="text-3xl font-bold leading-none uppercase font-rama lg:text-5xl text-blue">
              stay connected wherever you go
            </div>
            <div className="flex flex-col gap-4 text-sm sm:text-base">
              <p>
                Saily is an affordable, user-friendly and sustainable eSIM
                service that provides a stable, fast and secure internet
                connection when you’re traveling the world.
              </p>
              <p>
                Stay connected and secure with Saily, Lonely Planet’s
                recommended eSIM service, covering nearly all locations across
                Best in Travel and beyond.
              </p>
            </div>
            <Button
              href="https://go.saily.site/aff_c?offer_id=101&aff_id=5957&aff_sub=bitlogo&url_id=1344"
              target="_blank"
              onClick={() => {
                tagular("click", {
                  actionOutcome: "External Link",
                  outboundUrl:
                    "https://go.saily.site/aff_c?offer_id=101&aff_id=5957&aff_sub=bitlogo&url_id=1344",
                  webElement: {
                    location: "BIT_Saily_CTA",
                    elementType: "LINK",
                    position: "0",
                    text: "Get your eSIM",
                  },
                });
              }}
              rel="noopener nofollow"
              className="w-1/2 mt-2 text-center sm:w-content btn btn-primary sm:mx-0"
            >
              Get your eSIM
            </Button>
            <button
              className="hidden sm:pt-28 sm:mx-auto sm:mt-auto sm:flex sm:flex-col sm:gap-2 sm:h-content"
              type="button"
              onClick={() => {
                handleUpDownNavProvider(index, 1);
                tagular("click", {
                  actionOutcome: "SLIDE",
                  outboundUrl: "null",
                  webElement: {
                    location: "BIT_Saily_CTA",
                    elementType: "BUTTON",
                    position: "0",
                    text: "Keep exploring Best in Travel",
                  },
                });
              }}
            >
              <div>Keep exploring Best in Travel</div>
              <Arrow className="block mx-auto text-lg rotate-90 text-blue" />
            </button>
          </div>
        </div>

        {/* MEDIA SECTION */}
        <div className="relative flex h-full sm:order-2 sm:w-2/3">
          {inView && (
            <ImgixNextBackground
              wrapperClasses="w-full h-full"
              lazyload="true"
              quality={75}
              src="https://lonelyplanetstatic.imgix.net/marketing/best-in-travel/2025/saily-destination-large.jpg"
            />
          )}
        </div>
      </div>
    </div>
  );
}

SailyDestinationSection.propTypes = {
  index: PropTypes.number.isRequired,
};
